import {
  isAfter,
  isBefore,
  isFuture,
  isMatch,
  isSameDay,
  isValid,
  startOfToday,
  sub,
} from "date-fns";

export const validateOwnerBirthday = () => ({
  validate: (value: string | undefined) => {
    const date = new Date(String(value));
    const today = startOfToday();
    const _110YearsAgo = sub(today, { years: 110 });
    const _underage = sub(today, { years: 18 });

    return (
      isMatch(String(value), "yyyy-MM-dd") &&
      isValid(date) &&
      !isFuture(date) &&
      (isSameDay(date, _110YearsAgo) || !isBefore(date, _110YearsAgo)) &&
      (isSameDay(date, _underage) || !isAfter(date, _underage))
    );
  },
});
